export default __webpack_public_path__ + "d4a96b3c8c9482c13de6f0bf73a4aeb4.png";